import { render, staticRenderFns } from "./UserInsightModal.vue?vue&type=template&id=f4ab2638&scoped=true&"
import script from "./UserInsightModal.vue?vue&type=script&lang=js&"
export * from "./UserInsightModal.vue?vue&type=script&lang=js&"
import style0 from "./UserInsightModal.vue?vue&type=style&index=0&id=f4ab2638&prod&lang=scss&"
import style1 from "./UserInsightModal.vue?vue&type=style&index=1&id=f4ab2638&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ab2638",
  null
  
)

export default component.exports